import React from "react"
import { Helmet } from "react-helmet"
import { Box, Container, Flex, Link, Text } from "@chakra-ui/react"
import { useStaticQuery, graphql } from "gatsby"
import Navbar from "../components/Navbar"

export default function Layout(props) {
  const data = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            instagram
            twitter
          }
        }
      }
    `
  )
  const { siteMetadata } = data.site

  return (
    <Box minH="100vh">
      <Helmet>
        <html lang="zh-Hant" />
        <meta charSet="utf-8" />
        <title>{siteMetadata.title}</title>
        <link rel="canonical" href="https://podcast.overbuild.top" />
        <meta name="description" content={siteMetadata.description} />
      </Helmet>
      <Link
        href="#main-content"
        position="fixed"
        top="3"
        left="3"
        zIndex="skipLink"
        px="4"
        py="2"
        bg="white"
        color="brand.800"
        borderRadius="md"
        transform="translateY(-160%)"
        _focus={{ transform: "translateY(0)" }}
      >
        跳到主要內容
      </Link>
      <Container maxW="1180px" px={{ base: 5, md: 8 }}>
        <Navbar />
        <Box as="main" id="main-content" pb={{ base: 16, md: 24 }}>
          {props.children}
        </Box>
        <Flex
          as="footer"
          py="7"
          borderTopWidth="1px"
          borderColor="blackAlpha.200"
          align={{ base: "flex-start", sm: "center" }}
          justify="space-between"
          direction={{ base: "column", sm: "row" }}
          gap="3"
        >
          <Text fontSize="sm" color="blackAlpha.700">
            © {new Date().getFullYear()} 頂樓加蓋 Overbuild
          </Text>
          <Flex gap="5" fontSize="sm" fontWeight="600">
            <Link href={siteMetadata.instagram} isExternal>
              Instagram
            </Link>
            <Link href={siteMetadata.twitter} isExternal>
              X / Twitter
            </Link>
          </Flex>
        </Flex>
      </Container>
    </Box>
  )
}
